import { render, staticRenderFns } from "./ProviderDoctorList.vue?vue&type=template&id=48cd692b&scoped=true&lang=pug"
import script from "./ProviderDoctorList.vue?vue&type=script&lang=js"
export * from "./ProviderDoctorList.vue?vue&type=script&lang=js"
import style0 from "./ProviderDoctorList.vue?vue&type=style&index=0&id=48cd692b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48cd692b",
  null
  
)

export default component.exports